// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Heme","paramInput":"JobSimulator_paramInput__CYqku","input":"JobSimulator_input__1CiiH"};